<template>
    <div class="business-page">
        <div class="block vw-business-block">
            <nav class="btn-row">
                <router-link :to="{ name: 'coop', query: { business: businessName } }">
                    <span class="btn">{{lang.coop}}</span>
                </router-link>
            </nav>
            <div class="content-block">
                <div class="content custom-content editor-gen" v-html="detailContent"></div>
            </div>
        </div>
    </div>
</template>

<script>
import backSrc from '@/style/image/back.png';
import getLang from '@/utils/main/lang';
import ajax from '@/utils/ajax';
import Layout from '@/views/Layout.vue';
import router from '@/router';

export default {
    name: 'businessDetailBlock',
    components: {
        Layout,
    },
    props: {
        pageId: [String, Number],
    },
    data() {
        return {
            isCn: window.localStorage.getItem('show-lang') !== 'en',
            back: backSrc,
            lang: getLang(),
            banner: '',
            bannerTitle: '',
            detailContent: '',
            businessName: '',
        };
    },
    watch: {
        pageId() {
            this.renderNav();
        },
    },
    mounted() {
        this.renderNav();
    },
    methods: {
        goBack() {
            router.go(-1);
        },
        renderNav() {
            const id = this.$props.pageId;
            ajax.get('/web/business/business_detail.json', {
                id,
            }).then((result) => {
                this.detailContent = this.isCn ? result.data.cnContent : result.data.enContent;
                this.businessName = this.isCn ? result.data.cnBusinessName : result.data.enBusinessName;
            }).catch(() => {});
        },
    },
};
</script>
<style lang="less" scoped>
    .home-bg {
        background: #F1F1F1;
    }
    .vw-banner-container {
        width: 100%;
        height: 200px;
        position: relative;
        img {
            width: 100%;
            height: 100%;
        }
        strong {
            position: absolute;
            width: 80%;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            font-size: 32px;
            color: #fff;
            font-weight: 600;
            text-align: center;
            word-break: break-word;
        }
    }
    .btn-row {
        background: #fff;
        padding-bottom: 15px 0;
        width: 100%;
        display: flex;
        justify-content: flex-end;
        align-content: center;
        .btn {
            display: inline-block;
            margin-top: 11px;
            margin-right: 15px;
            padding: 0 12px 0 7px;
            background: url('../../style/image/right_trl.png') right 7px top 50% no-repeat #C71F4B;
            background-size: 4px 5px;
            color: #fff;
            font-size: 12px;
            height: 22px;
            line-height: 22px;
        }
    }
    .content-block {
        background: #fff;
        padding: 15px 0;
    }
</style>
